module.exports = __webpack_public_path__ + "static/media/Rectangle 115.64185b3a.png";